<template>
  <div>
    <HeaderPage>
      <div class="container mt-4">
        <h1>Locations</h1>
        <!-- Champ de recherche -->
        <p>Rechercher un client</p>
        <input
          type="text"
          v-model="searchQuery"
          class="form-control mb-3"
          placeholder="Rechercher un client..."
        />

        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Date début</th>
                <th>Date fin</th>
                <th>Nom Client</th>
                <th>Téléphone</th>
                <th>Adresse</th>
                <th>Prix Total en Ariary</th>
                <th>Reste à payer en Ariary</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(client, clientNom) in filteredClients" :key="clientNom">
                <td>{{ client.date_debut }}</td>
                <td>{{ client.date_fin }}</td>
                <td>{{ clientNom }}</td>
                <td>{{ client.telephone }}</td>
                <td>{{ client.adresse }}</td>
                <td style="text-align: right;"> {{ formatNumber(calculateTotalPrix(client)) }}</td>
                <td style="text-align: right;">
                    {{ formatNumber(client.balance !== null ? client.balance : calculateTotalPrix(client)) }}
                </td>
                <td style="text-align: center;">
                  <span
  class="badge"
  :class="{
    'bg-success': getReste(client) === 0,
    'bg-warning text-dark': getReste(client) > 0,
    'bg-secondary': getReste(client) === null
  }"
>
  {{
    getReste(client) === null
      ? 'En attente'
      : getReste(client) > 0
      ? 'En cours'
      : 'Validé'
  }}
</span>


                </td>

                <td style="text-align: right;">
                  <div class="btn-group" role="group">
                    <button type="button" class="btn btn-primary btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" @click="openArticlesModal(client)" title="Voir Articles Loués">
                          Voir Articles
                        </a>
                      </li>
                      <li v-if="(client.balance !== null ? client.balance : calculateTotalPrix(client)) > 0">
                        <a class="dropdown-item" @click="openPaymentModal(client)" title="Payer">
                          Payer
                        </a>
                      </li>


                      <li>
                        <a class="dropdown-item" @click="generateInvoice(client)" title="Facturer">
                          <i class="fas fa-file-invoice-dollar"></i> Facturer
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" @click="openReceiptModal(client)" title="Reçu des paiements">
                          <i class="fas fa-receipt"></i> Reçu des paiements
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </HeaderPage>

    <!-- Modal Bootstrap pour le paiement -->
    <div class="modal fade" id="paymentModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Paiement de la location</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p><strong>Client :</strong> {{ selectedClient.nom }}</p>
            <p><strong>Total :</strong> {{ calculateTotalPrix(selectedClient) }} Ariary</p>
            <div class="form-check">
              <input class="form-check-input" type="radio" id="payFull" value="full" v-model="paymentType" />
              <label class="form-check-label" for="payFull">Payer tout</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" id="payAdvance" value="advance" v-model="paymentType" />
              <label class="form-check-label" for="payAdvance">Payer acompte</label>
            </div>
            <div v-if="paymentType === 'advance'" class="mt-3">
              <label for="advanceAmount" class="form-label">Montant de l'avance</label>
              <input type="number" class="form-control" id="advanceAmount" v-model="advanceAmount" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="confirmPayment">Confirmer</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Annuler</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour afficher les paiements (Reçu) -->
    <div class="modal fade" id="receiptModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Historique des paiements</h5>
            <button type="button" class="btn-close" @click="closeReceiptModal" aria-label="Close"></button>
          </div>
          <!-- Contenu du reçu (tableau des paiements) -->
          <div class="modal-body" id="receiptContent">
            <div v-if="payments.length">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Type de paiement</th>
                    <th>Montant payé</th>
                    <th>Montant total</th>
                    <th>Reste à payer</th>
                    <th>Date de paiement</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(payment, index) in payments" :key="index">
                    <td>
                      {{ payment.payment_type === 'full' ? 'Tout' : (payment.payment_type === 'advance' ? 'Avance' : payment.payment_type) }}
                    </td>
                    <td style="text-align: right;">{{ formatNumber(payment.amount) }} Ariary</td>
                    <td style="text-align: right;">{{ formatNumber(payment.total_amount) }} Ariary</td>
                    <td style="text-align: right;">{{ formatNumber(payment.balance) }} Ariary</td>
                    <td>{{ payment.payment_date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Aucun paiement trouvé pour cette location.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="generateReceiptPDF">Imprimer</button>
            <button type="button" class="btn btn-danger" @click="closeReceiptModal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pour afficher les articles loués -->
    <div class="modal fade" id="articlesModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Articles Loués pour {{ selectedClient.nom }}</h5>
            <button type="button" class="btn-close" @click="closeArticlesModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="selectedClient.articles && selectedClient.articles.length">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Date début</th>
                    <th>Date fin</th>
                    <th>Désignation</th>
                    <th>Quantité</th>
                    <th>Prix Unitaire</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(article, index) in selectedClient.articles" :key="index">
                    <td>{{ article.date_debut }}</td>
                    <td>{{ article.date_fin }}</td>
                    <td>{{ article.nom_article }}</td>
                    <td>{{ article.quantite }}</td>
                    <td style="text-align: right;">
                      {{ (article.prix_total / article.quantite).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} Ariary
                    </td>
                    <td style="text-align: right;">{{ formatNumber(article.prix_total) }} Ariary</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Aucun article loué trouvé pour ce client.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="closeArticlesModal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin Modal Articles -->
  </div>
</template>

<script>
import axios from "axios";
import n2words from 'n2words';
import HeaderPage from "./components/HeaderPage.vue";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import html2pdf from "html2pdf.js";
import QRCode from "qrcode";

export default {
  name: "AddLocation",
  components: { HeaderPage },
  data() {
    return {
      clients: [],
      groupedClients: {},
      selectedClient: {},
      selectedLocationId: null,
      paymentType: "full",
      advanceAmount: 0,
      searchQuery: "",
      payments: [],
      paymentModalInstance: null,
      receiptModalInstance: null,
      articlesModalInstance: null,
    };
  },
  computed: {
    filteredClients() {
      if (!this.searchQuery) return this.groupedClients;
      return Object.fromEntries(
        Object.entries(this.groupedClients).filter(([key]) =>
          key.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      );
    },
  },
  mounted() {
    this.fetchTableData();
    this.paymentModalInstance = new bootstrap.Modal(document.getElementById("paymentModal"));
    this.receiptModalInstance = new bootstrap.Modal(document.getElementById("receiptModal"));
    this.articlesModalInstance = new bootstrap.Modal(document.getElementById("articlesModal"));
    const dropdownElements = document.querySelectorAll('.dropdown-toggle');
    dropdownElements.forEach(el => new bootstrap.Dropdown(el));
  },
  methods: {
    async fetchTableData() {
      try {
        const API_URL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${API_URL}/api/users/clients`);
        this.clients = response.data;
        this.groupClients();
        this.updateBalances();
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    },

    formatNumber(num) {
      return Number(num).toLocaleString('fr-FR');
    },
    getReste(client) {
    if (client.balance === null || client.balance === undefined) {
      return null;
    }
    return Number(client.balance);
  },

    getResteAPayer(client) {
    return client.balance !== null ? Number(client.balance) : Number(this.calculateTotalPrix(client));
  },
    groupClients() {
      this.groupedClients = this.clients.reduce((acc, client) => {
        const clientId = client.client_id || client.id;
        const locationId = client.location_id || (client.articles ? client.articles[0].location_id : null);
        if (!acc[client.client_nom]) {
          acc[client.client_nom] = {
            id: clientId,
            location_id: locationId,
            nom: client.client_nom,
            telephone: client.client_telephone,
            adresse: client.client_adresse,
            date_debut: client.date_debut,
            date_fin: client.date_fin,
            articles: [],
            totalPrix: 0,
            balance: null,
            location_type: client.location_type || "par_jour",
            prix_location: client.prix_location || 0,
          };
        }
        acc[client.client_nom].articles.push({
          location_id: client.location_id,
          nom_article: client.nom_article,
          quantite: client.quantite,
          prix_total: client.prix_total,
          date_debut: client.date_debut,
          date_fin: client.date_fin,
        });
        acc[client.client_nom].totalPrix += client.prix_total;
        return acc;
      }, {});
    },
    async updateBalances() {
      const API_URL = process.env.VUE_APP_API_URL;
      for (let clientName in this.groupedClients) {
        const client = this.groupedClients[clientName];
        const locationId = client.location_id;
        if (locationId) {
          try {
            const response = await axios.get(`${API_URL}/api/payments/${locationId}`);
            const payments = response.data;
            if (payments.length > 0) {
              const lastPayment = payments[payments.length - 1];
              client.balance = parseFloat(lastPayment.balance);
            } else {
              client.balance = this.calculateTotalPrix(client);
            }
          } catch (error) {
            console.error("Erreur lors de la récupération des paiements pour la location", locationId, error);
            client.balance = this.calculateTotalPrix(client);
          }
        } else {
          client.balance = this.calculateTotalPrix(client);
        }
      }
    },
    calculateTotalPrix(client) {
      if (client.location_type === "par_jour") {
        const dateDebut = new Date(client.date_debut);
        const dateFin = new Date(client.date_fin);
        const diffTime = Math.abs(dateFin - dateDebut);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) || 1;
        let total = 0;
        client.articles.forEach(article => {
          const prixUnitaire = article.prix_total / article.quantite;
          total += diffDays * article.quantite * prixUnitaire;
        });
        return total;
      } else if (client.location_type === "forfaitaire") {
        return client.prix_location;
      } else {
        return client.totalPrix;
      }
    },
    openPaymentModal(client) {
      this.selectedClient = client;
      this.paymentType = "full";
      this.advanceAmount = 0;
      this.paymentModalInstance.show();
    },
    confirmPayment() {
      if (
        this.paymentType === "advance" &&
        (this.advanceAmount <= 0 || this.advanceAmount >= this.calculateTotalPrix(this.selectedClient))
      ) {
        alert("Veuillez entrer un montant valide pour l'avance.");
        return;
      }
      const API_URL = process.env.VUE_APP_API_URL;
      const amountToPay =
        this.paymentType === "full"
          ? (this.selectedClient.balance !== null ? this.selectedClient.balance : this.calculateTotalPrix(this.selectedClient))
          : this.advanceAmount;
      const paymentData = {
        location_id: this.selectedClient.location_id || this.selectedClient.id,
        payment_type: this.paymentType,
        amount: amountToPay,
        total_amount: this.calculateTotalPrix(this.selectedClient),
      };

      axios
        .post(`${API_URL}/api/payments`, paymentData)
        .then(response => {
          console.log("Paiement enregistré :", response.data);
          alert("Paiement enregistré avec succès !");
          this.selectedClient.balance = response.data.payment.balance;
          this.paymentModalInstance.hide();
          this.updateBalances();
        })
        .catch(error => {
          console.error("Erreur lors du paiement :", error);
          alert("Erreur lors du paiement.");
        });
    },
    openReceiptModal(client) {
      this.selectedClient = client;
      const API_URL = process.env.VUE_APP_API_URL;
      const locationId =
        client.location_id ||
        (client.articles && client.articles.length ? client.articles[0].location_id : null);

      if (!locationId) {
        alert("Aucun ID de location trouvé pour ce client.");
        return;
      }
      this.selectedLocationId = locationId;

      axios
        .get(`${API_URL}/api/payments/${locationId}`)
        .then(response => {
          this.payments = response.data;
          this.receiptModalInstance.show();
        })
        .catch(error => {
          console.error("Erreur lors de la récupération des paiements :", error);
          alert("Erreur lors de la récupération des paiements.");
        });
    },
    closeReceiptModal() {
      this.receiptModalInstance.hide();
    },
    openArticlesModal(client) {
      this.selectedClient = client;
      this.articlesModalInstance.show();
    },
    closeArticlesModal() {
      this.articlesModalInstance.hide();
    },
    async generateInvoice(client) {
      const API_URL = process.env.VUE_APP_API_URL;
      const currentDate = new Date();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const year = currentDate.getFullYear();
      
      // Utilisation de l'ID de location du client comme base pour le numéro de facture
      const locationId = client.location_id || client.id;
      const invoiceNumber = `INV${locationId}/${month}/${year}`;
      const total = this.calculateTotalPrix(client);
      const totalEnLettres = n2words(total, { lang: 'fr' });

      
      // Générer le QR code contenant le numéro de facture
      let qrCodeDataUrl = "";
      try {
        qrCodeDataUrl = await QRCode.toDataURL(invoiceNumber);
      } catch (err) {
        console.error("Erreur lors de la génération du QR Code :", err);
      }

      // Construction du HTML de la facture avec le numéro de facture, le QR code et les informations clients
      const invoiceHTML = `
      <div style="font-family: Arial, sans-serif; margin: 20px;">
        <div class="invoice-header" style="text-align: center; margin-bottom: 20px;">
          <img src="/assets/logoMirindraa.PNG" alt="logo" class="img-fluid" style="max-width: 120px;" />
          <h1>Facture</h1>
          <p>Date : ${currentDate.toLocaleDateString("fr-FR")}</p>
          <p>Numéro de facture : ${invoiceNumber}</p>
          <div style="margin-top: 10px;">
            <img src="${qrCodeDataUrl}" alt="QR Code" style="max-width: 100px;" />
          </div>
          <div class="company-info" style="margin-top: 10px; font-size: 14px;">
            <p><strong>Coopérative Mirindra</strong></p>
            <p>Adresse : Lot b 159 ter alasora</p>
            <p>Contact : 0320711483, 0320711383, 0320711420</p>
          </div>
        </div>
        <div class="client-info" style="margin: 15px 0;">
          <p><strong>Nom et prénom :</strong> ${client.nom || client.client_nom}</p>
          <p><strong>Adresse :</strong> ${client.adresse || client.client_adresse || ""}</p>
          <p><strong>Contact :</strong> ${client.contact || client.telephone || ""}</p>
        </div>
        <table style="width: 100%; border-collapse: collapse; margin-top: 20px;">
          <thead>
            <tr>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Date début</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Date fin</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Désignation</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Quantité</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Prix Unitaire</th>
              <th style="border: 1px solid #ddd; padding: 8px; background-color: #f2f2f2;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${client.articles
              .map(
                article => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px;">${article.date_debut}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">${article.date_fin}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">${article.nom_article}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">${article.quantite}</td>
                <td style="border: 1px solid #ddd; padding: 8px;">
                    ${(article.prix_total / article.quantite).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Ariary
                </td>
                <td style="border: 1px solid #ddd; padding: 8px;">
                  ${article.prix_total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Ariary
                </td>

              </tr>
            `
              )
              .join("")}
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" style="border: 1px solid #ddd; padding: 8px; text-align: right; font-weight: bold;">Total Général</td>
              <td style="border: 1px solid #ddd; padding: 8px; font-weight: bold;">
  ${this.calculateTotalPrix(client).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Ariary
</td>

            </tr>
          </tfoot>
        </table>
        <div>
          <p>Arrêter la présente facture à la somme de ${totalEnLettres} Ariary</p>
        </div>
        <div class="signature" style="margin-right: 40px; text-align: center;">
          <p>Le responsable :</p>
        </div>
      </div>
      `;

      // Enregistrer le numéro de facture dans la base de données
      axios.post(`${API_URL}/api/invoices`, {
        invoice_number: invoiceNumber,
        location_id: locationId,
        total_amount: this.calculateTotalPrix(client),
        invoice_date: currentDate.toISOString().split('T')[0]
      })
      .then(response => {
        console.log("Numéro de facture enregistré :", response.data);
        // Mise à jour de la fiche de location avec le numéro de facture
        axios.patch(`${API_URL}/api/locations/${locationId}`, {
          invoice_number: invoiceNumber
        })
        .then(resp => {
          console.log("Location mise à jour avec le numéro de facture :", resp.data);
        })
        .catch(err => {
          console.error("Erreur lors de la mise à jour de la location :", err);
        });
      })
      .catch(error => {
        console.error("Erreur lors de l'enregistrement du numéro de facture :", error);
      });

      // Générer le PDF de la facture
      const invoiceContainer = document.createElement("div");
      invoiceContainer.innerHTML = invoiceHTML;
      document.body.appendChild(invoiceContainer);
      const opt = {
        margin: 10,
        filename: "facture.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }
      };
      html2pdf()
        .set(opt)
        .from(invoiceContainer)
        .save()
        .then(() => {
          document.body.removeChild(invoiceContainer);
        })
        .catch(error => {
          console.error("Erreur lors de la génération du PDF :", error);
        });
    },
    generateReceiptPDF() {
      // Génération d'un numéro de reçu pour le PDF basé sur l'ID de location et la date
      const currentDate = new Date();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const year = currentDate.getFullYear();
      const receiptNumber = `REC${this.selectedLocationId}/${month}/${year}`;

      // Construction d'un nouveau conteneur HTML pour le reçu incluant l'en-tête avec le numéro de reçu
      const originalContent = document.getElementById("receiptContent").innerHTML;
      const receiptHTML = `
      <div style="font-family: Arial, sans-serif; margin: 20px;">
        <div style="text-align: center; margin-bottom: 20px;">
          <h1>Reçu de Paiement</h1>
          <p>Date : ${currentDate.toLocaleDateString("fr-FR")}</p>
          <p>Numéro de reçu : ${receiptNumber}</p>
        </div>
        ${originalContent}
      </div>
      `;

      // Création d'un conteneur temporaire pour générer le PDF du reçu
      const receiptContainer = document.createElement("div");
      receiptContainer.innerHTML = receiptHTML;
      document.body.appendChild(receiptContainer);
      const opt = {
        margin: 5,
        filename: "recu_paiement.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: [200, 297], orientation: "portrait" }
      };
      html2pdf()
        .set(opt)
        .from(receiptContainer)
        .save()
        .then(() => {
          document.body.removeChild(receiptContainer);
        })
        .catch(error => {
          console.error("Erreur lors de la génération du PDF du reçu :", error);
        });
    }
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}
.btn-sm {
  font-size: 0.8rem;
  padding: 5px 8px;
}
.modal-body p {
  margin-bottom: 0.5rem;
}
.form-check {
  margin-bottom: 10px;
}
</style>
